import React, { useState } from 'react';
import {
  UserNotificationProviderProps,
  UserNotification,
} from './userNotification.interface';
import { UserNotificationContext } from './userNotificationContext';

import { UserNotificationType } from './userNotificationType.enum';

export function UserNotificationProvider({
  children,
}: UserNotificationProviderProps) {
  const [notifications, setNotifications] = useState<UserNotification[]>([]);

  const addUserNotification = (
    title: string,
    message: string,
    type: UserNotificationType,
  ) => {
    const id = Date.now();
    const newNotification: UserNotification = { id, title, message, type };
    setNotifications([newNotification]);
  };

  const removeNotification = () => {
    setNotifications([]);
  };

  return (
    <UserNotificationContext.Provider
      value={{ notifications, addUserNotification, removeNotification }}
    >
      {children}
    </UserNotificationContext.Provider>
  );
}
